import VideoBlock from './component';

export default VideoBlock;
